import React, { useState, useEffect, useContext } from "react";
import { connect } from "react-redux";
import { TableContext } from "../../index";
import {
    startValidation, startValidationList, stopValidationList
} from "../ruleService";
import { showSuccessToast, showWarningToast } from "../../validation/ToastContainer";
import { ValidationStatus } from "../../vars";
import { Loader2, PlayCircle } from "lucide-react";
import * as deviceService from "../../devices/deviceService";


function ValidateButton({ deviceId, msbId, validationStatus, setValidationStatus, userCapability }) {
    //Added isClicked  by Octopus DevTeam july 15-2022
    //const [isClicked, setClicked] = useState(false);
    const { config, setConfig } = useContext(TableContext);
    //#region Set User Capabilities
    const [validateButtonCapability, setValidateButtonCapability] = useState(-1);
    useEffect(() => {
        if (userCapability) {
            const validateButtonPermission = userCapability.find(item =>
                item.component === "validatebutton" && item.type === "field")?.permission;
            setValidateButtonCapability(validateButtonPermission);
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);
    //#endregion

    const isDisabled = () => {
        if (validationStatus === ValidationStatus.PROCESSING) {
            return true;
        }
        if (!deviceId || !msbId) {
            return true;
        }
        if (validateButtonCapability === 0) {
            return true;
        }
        return deviceId < 0 || msbId < 0;

    }


    const buttonDisabled = isDisabled();

    const startValidateRulesForDevice = async (e) => {
        // alert('startValidateRulesForDevice')
        if (buttonDisabled === true) return;
        e.preventDefault()
        setValidationStatus(ValidationStatus.PROCESSING);

        //Added November 18,2022
        //Check if the device is disabled or no before executing the validation process
        let device;
        try {
            device = await deviceService.loadById(deviceId);
        } catch (error) {
            setValidationStatus(ValidationStatus.DONE);
            showWarningToast('Unable to load device details, please try again', 'Validate');
            return;
        }

        if (device.disabled === false) {
            setValidationStatus(ValidationStatus.DONE);
            showWarningToast('Device is not enabled, Enable it to execute validation', 'Disabled Device');
        } else {
            //get selected devices by id and then get rulePk selected devices
            const ruleIdList = config.selected.length ? config.selected.map(deviceId => {
                return config.devices.find(device => device.id === deviceId).rulePk
            }) : []

            const validationResultPkList = config.selected //Id of validation result

            // if (ruleIdList.length) {
            //     // alert('if(ruleIdList.length)')
            //     if (!buttonDisabled) {
            //         setValidationStatus(ValidationStatus.PROCESSING);
            //         return startValidationList(deviceId, ruleIdList, validationResultPkList, msbId)
            //             .then(() => showSuccessToast('Validation started', 'Validate'));
            //     }
            // }
            if (!buttonDisabled) {
                try {
                    const success = ruleIdList.length
                        ? await startValidationList(deviceId, ruleIdList, validationResultPkList, msbId)
                        : await startValidation(deviceId, msbId);

                    if (success) {
                        showSuccessToast(`Validation Completed For ${device.hostName}`, 'Validate');
                    } else {
                        showWarningToast(`Validation did not complete for ${device.hostName}`, 'Validate');
                    }
                } catch (error) {
                    showWarningToast(`Validation did not complete for ${device.hostName}`, 'Validate');
                } finally {
                    setValidationStatus(ValidationStatus.DONE);
                    setConfig({ ...config, lastUpdated: Date.now() });
                }
            }
        }
    }

    const showSpinner = validationStatus === ValidationStatus.PROCESSING;

    //Added by Octopus Devteam June 17-2022 
    const stopValidateRulesForDevice = (e) => {

        e.preventDefault();

        //get selected devices by id and then get rulePk selected devices
        // eslint-disable-next-line no-unused-vars
        // const ruleIdList = config.selected.length ? config.selected.map(deviceId => {
        //     return config.devices.find(device => device.id === deviceId).rulePk
        // }) : []

        // const validationResultPkList = config.selected //Id of validation result

        return stopValidationList(deviceId)
            .then(() => showSuccessToast('Stopping Validation', 'Stop Validation'))
            .then(() => setValidationStatus(ValidationStatus.DONE))
            .then(() => setConfig({ ...config, lastUpdated: Date.now() }))
    }

    return (
        <div className="d-flex align-items-center">
            <button
                className={`oct_btn-validate-v2 ${buttonDisabled ? 'disabled' : ''}`}
                onClick={buttonDisabled ? null : startValidateRulesForDevice}
                disabled={buttonDisabled}
            >
                {showSpinner ? (
                    <>
                        <Loader2 className="oct_icon animate-spin" />
                        Validating...
                    </>
                ) : (
                    <>
                        <PlayCircle className="oct_icon" />
                        Validate
                    </>
                )}
            </button>

            {validationStatus === ValidationStatus.PROCESSING && (
                <button
                    className={`btn oct_btn-outline-v2 stop-validation ml-2 ${validateButtonCapability === 0 ? 'disabled' : ''}`}
                    onClick={validateButtonCapability <= 0 ? null : stopValidateRulesForDevice}
                    disabled={validateButtonCapability <= 0}
                >
                    Stop Validation
                </button>
            )}
        </div>
    )

}

function mapStateToProps(state) {
    const auth = state.auth;
    return {
        userCapability: auth.userCapability,
    }
}

export default connect(mapStateToProps)(ValidateButton);
